import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getOrderGeneratorsFieldsWorks: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].GET_ORDER_GENERATORS_FIELDS_WORKS,
	},
	getOrderGeneratorsFieldsWork: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].GET_ORDER_GENERATORS_FIELDS_WORK,
	},
	createOrderGeneratorsFieldsWork: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].CREATE_ORDER_GENERATORS_FIELDS_WORK,
	},
	putOrderGeneratorsFieldsWork: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].PUT_ORDER_GENERATORS_FIELDS_WORK,
	},
	patchOrderGeneratorsFieldsWork: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].PATCH_ORDER_GENERATORS_FIELDS_WORK,
	},
	deleteOrderGeneratorsFieldsWork: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].DELETE_ORDER_GENERATORS_FIELDS_WORK,
	},
	getOrderGeneratorsFieldsWorkPreview: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].GET_ORDER_GENERATORS_FIELDS_WORK_PREVIEW,
	},
	getOrderGeneratorsFieldsWorkPopup: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].GET_ORDER_GENERATORS_FIELDS_WORK_POPUP,
	},
	getOrderGeneratorsFieldsWorkRelatedPlanWorks: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].GET_ORDER_GENERATORS_FIELDS_WORK_RELATED_PLAN_WORKS,
	},
}
